// @flow
import { SplitFactory } from '@splitsoftware/splitio';
import * as Constants from './constants';

export const makeFlagList = function(
  flagsConfiguration: Object = Constants.flags
) {
  return Object.values(flagsConfiguration);
};

export const makeSplitClient = function(customerKey: string) {
  // configurations are in seconds
  return SplitFactory({
    startup: {
      requestTimeoutBeforeReady: 5,
      retriesOnFailureBeforeReady: 1,
      readyTimeout: 5,
      eventsFirstPushWindow: 10
    },
    core: {
      authorizationKey: getSplitAuthorizationKey(),
      key: customerKey,
      trafficType: 'user',
      labelsEnabled: true
    },
    scheduler: {
      featuresRefreshRate: 30,
      segmentsRefreshRate: 60,
      metricsRefreshRate: 60,
      impressionsRefreshRate: 60,
      eventsPushRate: 60,
      eventsQueueSize: 500,
      offlineRefreshRate: 30000
    },
    storage: {
      type: 'LOCALSTORAGE'
    },
    debug: isSplitDebugMode(),
    features: getSplitMockFeatures()
  }).client();
};

export const getSplitAuthorizationKey = () => {
  return process.env.SPLIT_AUTHORIZATION_KEY;
};

export const isSplitDebugMode = () => {
  switch (process.env.ENV) {
  default:
    return false;
  }
};

export const isSplitLocalMode = () => process.env.SPLIT_AUTHORIZATION_KEY === 'localhost';

export const getSplitMockFeatures = (isSplitDebugMode: boolean = false) => {
  return isSplitLocalMode() ? Constants.localhostTreatments : null;
};



// WEBPACK FOOTER //
// ./src/app/modules/features/utils.js